import { render, staticRenderFns } from "./modalInfos.vue?vue&type=template&id=189fd709&scoped=true&"
import script from "./modalInfos.vue?vue&type=script&lang=js&"
export * from "./modalInfos.vue?vue&type=script&lang=js&"
import style0 from "./modalInfos.vue?vue&type=style&index=0&id=189fd709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189fd709",
  null
  
)

export default component.exports